import { useOperation } from '../../../types/Operation.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindAuctionHouseByCreatorAndMintOperation';

/**
 * Finds an Auction House by its creator and treasury mint.
 *
 * ```ts
 * const nft = await metaplex
 *   .auctionHouse()
 *   .findByCreatorAndMint({ creator, treasuryMint };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findAuctionHouseByCreatorAndMintOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findAuctionHouseByCreatorAndMintOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      creator,
      treasuryMint
    } = operation.input;
    return metaplex.auctionHouse().findByAddress({
      address: metaplex.auctionHouse().pdas().auctionHouse({
        creator,
        treasuryMint,
        programs: scope.programs
      }),
      ...operation.input
    }, scope);
  }
};

export { findAuctionHouseByCreatorAndMintOperation, findAuctionHouseByCreatorAndMintOperationHandler };
//# sourceMappingURL=findAuctionHouseByCreatorAndMint.mjs.map
